import { Injectable, NgZone } from '@angular/core';
import { GeralGoApi } from '@gestor-web/@core/api/go';
import { NotificationService } from '@gestor-web/app/shared/services';
import { BehaviorSubject } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WebchatService {
  private zendeskFunction: Function;

  private token$ = new BehaviorSubject<string>(null);
  private showIcon$ = new BehaviorSubject<boolean>(false);
  private unreadCount$ = new BehaviorSubject<number>(0);

  constructor(
    private geralGoApi: GeralGoApi,
    private notification: NotificationService,
    private zone: NgZone,
  ) {
    this.init();
  }

  init() {
    // console.log('[Webchat] init...');
    this.zendeskFunction = window['zE'];

    if (!this.zendeskFunction) {
      // console.log('[Webchat] init... function not found');
      return;
    }

    // console.log('[Webchat] init... initializing!');
    this.zendeskFunction('messenger:on', 'unreadMessages', count => {
      // console.log('[Webchat] on:unreadMessages', count);
      this.zone.run(() => {
        this.unreadCount$.next(count);
        if (count > 0) {
          this.showIcon$.next(true);
        }
      });
    });

    this.zendeskFunction('messenger:on', 'close', () => {
      // console.log('[Webchat] on:close');
      this.zone.run(() => this.showIcon$.next(true));
    });
  }

  private doLogin(force?: false) {
    // console.log('[Geral] doLogin - force:', force);
    if (this.token$.value && !force) {
      return this.token$.pipe(first());
    }

    return this.geralGoApi.getZendeskJwtToken().pipe(
      map(response => {
        const token = response?.token;
        if (!token) {
          console.warn('Invalid token: ', response);
          return null;
        }
        this.token$.next(token);
        this.zendeskFunction('messenger', 'loginUser', callback => callback(token));
        return token;
      }),
    );
  }

  getToken() {
    return this.token$.asObservable();
  }

  getUnreadCount() {
    return this.unreadCount$.asObservable();
  }

  getShowIcon() {
    return this.showIcon$.asObservable();
  }

  showWebchat() {
    // console.log('[Geral] showWebchat');
    this.doLogin().subscribe(response => {
      if (!response) {
        this.notification.warn('Ocorreu um erro ao abrir o Chat');
        return;
      }
      this.zendeskFunction('messenger', 'open');
    });
  }

  hideWebchat() {
    // console.log('[Geral] hideWebchat');
    this.zendeskFunction('messenger', 'close');
  }

  showIcon() {
    this.showIcon$.next(true);
  }

  hideIcon() {
    this.showIcon$.next(false);
  }
}
